// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"1bf823bf","453":"2190ce60","889":"a605eb4f"}[chunkId] + ".chunk.js";
};